import { useEffect, useState } from "react";
import FormField from "./FormField";
import apiCall from "../helper/apiCall";

const ProductUploadSpecificationForm = ({ formData, onNext, onBack, allFormData }) => {
  const [localData, setLocalData] = useState(formData);
  const [errors, setErrors] = useState({});
  const [gender, setGender] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [childCategories, setChildCategories] = useState([]);
  const [fabrics, setFabrics] = useState([]);
  const [materials, setMaterials] = useState([]);
  const [neckStyleNames, setNeckStyleNames] = useState([]);
  const [occasions, setOccasions] = useState([]);
  const [ornamentation, setOrnamentation] = useState([]);
  const [patterns, setPatterns] = useState([]);
  const [sleeves, setSleeves] = useState([]);
  const [closuretypes, setClosuretypes] = useState([]);
  const [backTypeNames, setBackTypeNames] = useState([]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setLocalData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (errors[name]) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    }
  };

  const validate = () => {
    const newErrors = {};
    if (!localData.gender_id) newErrors.gender_id = 'Gender is required.';
    //if (!localData.material_id) newErrors.material_id = 'Material is required.';
    if (!localData.occasion_id) newErrors.occasion_id = 'Occasion is required.';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleNextClick = () => {
    if (validate()) {
      onNext(localData);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (!value) {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: `${e.target.labels[0].textContent.replace(' *', '')} is required.` }));
    } else {
      setErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
    }
  };

  const getSubCategories = async (categoryId) => {
    if (!categoryId) {
      setSubCategories([]);
      return;
    }
    try {
      const result = await apiCall('getSubCategories');
      console.log('result:',result)
      const filteredData = result.data.filter(subCat => subCat.category_id == categoryId);
      setSubCategories(filteredData);
    } catch (error) {
      console.error("Failed to fetch sub categories:", error);
    }
  };

  const getChildCategories = async (categoryId) => {
    if (!categoryId) {
      setSubCategories([]);
      return;
    }
    try {
      const result = await apiCall('getChildCategories',{ categoryId });
      console.log('result:',result)
      const filteredData = result.data.filter(subCat => subCat.category_id == categoryId);
      setSubCategories(filteredData);
    } catch (error) {
      console.error("Failed to fetch sub categories:", error);
    }
  };

  

  const getGender = async () => {
    try {
      const result = await apiCall('getGender');
      setGender(result.data);
    } catch (error) {
      console.error("Failed to fetch gender:", error);
    }
  };

  const getBackTypeNames = async () => {
    try {
      const result = await apiCall('getBackTypeNames');
      setBackTypeNames(result.data);
    } catch (error) {
      console.error("Failed to fetch getBackTypeNames:", error);
    }
  };

  const getFabrics = async () => {
    try {
      const result = await apiCall('getFabrics');
      setFabrics(result.data);
    } catch (error) {
      console.error("Failed to fetch fabrices:", error);
    }
  };

  const getMaterials = async () => {
    try {
      const result = await apiCall('getMaterials');
      setMaterials(result.data);
    } catch (error) {
      console.error("Failed to fetch materials:", error);
    }
  };

  const getNeckStyleNames = async () => {
    try {
      const result = await apiCall('getNeckStyleNames');
      setNeckStyleNames(result.data);
    } catch (error) {
      console.error("Failed to fetch getNeckStyleNames:", error);
    }
  };

  const getOccasions = async () => {
    try {
      const result = await apiCall('getOccasions');
      setOccasions(result.data);
    } catch (error) {
      console.error("Failed to fetch getOccasions:", error);
    }
  };

  const getOrnamentation = async () => {
    try {
      const result = await apiCall('getOrnamentation');
      setOrnamentation(result.data);
    } catch (error) {
      console.error("Failed to fetch getOrnamentation:", error);
    }
  };

  const getPatterns = async () => {
    try {
      const result = await apiCall('getPatterns');
      setPatterns(result.data);
    } catch (error) {
      console.error("Failed to fetch getPatterns:", error);
    }
  };

  const getSleeves = async () => {
    try {
      const result = await apiCall('getSleeves');
      setSleeves(result.data);
    } catch (error) {
      console.error("Failed to fetch getSleeves:", error);
    }
  };

  const getClosureTypes = async () => {
    try {
      const result = await apiCall('getClosureTypes');
      setClosuretypes(result.data);
    } catch (error) {
      console.error("Failed to fetch getClosureTypes:", error);
    }
  };

  // Initial data fetch for static lists
  useEffect(() => {
    getGender();
    getFabrics();
    getOccasions();
    getOrnamentation();
    getPatterns();
    getClosureTypes();
    getSleeves();
    getMaterials();
    getNeckStyleNames();
    getBackTypeNames();
  }, []);

  // UseEffect to fetch subcategories based on the selected category from the General form
  // useEffect(() => {
  //   console.log('allFormData:',allFormData);
  //   const categoryId = allFormData.general?.category_id;
  //   if (categoryId) {
  //     getSubCategories(categoryId);
  //   } else {
  //     // If no category is selected, clear the subcategories and the local state
  //     setSubCategories([]);
  //     setLocalData(prevData => ({ ...prevData, sub_category_id: '' }));
  //   }
  // }, [allFormData.general?.category_id]);


  return (
    <div className="flex flex-col space-y-4">
      <h2 className="text-xl font-semibold mb-4">Product Specification</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* <FormField
          label="Sub Category"
          id="sub_category_id"
          type="select"
          value={localData.sub_category_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          required={true}
          errorMessage={errors.sub_category_id}
        >
          <option value="">Select sub category</option>
          {subCategories.map((el) => (
            <option key={el.sub_category_id} value={el.sub_category_id}>
              {el.sub_category_name}
            </option>
          ))}
        </FormField> */}
        <FormField
          label="Gender"
          id="gender_id"
          type="select"
          value={localData.gender_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          required={true}
          errorMessage={errors.gender_id}
        >
          <option value="">Select Gender</option>
          {gender.map((el) => (
            <option key={el.gender_id} value={el.gender_id}>
              {el.gender_name}
            </option>
          ))}
        </FormField>
        <FormField
          label="Occassion"
          id="occasion_id"
          type="select"
          value={localData.occasion_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          
          errorMessage={errors.occasion_id}
        >
          <option value="">Select occasion</option>
          {occasions.map((el) => (
            <option key={el.occasion_id} value={el.occasion_id}>
              {el.occasion_name}
            </option>
          ))}
        </FormField>
        <FormField
          label="Fabric"
          id="fabric_id"
          type="select"
          value={localData.fabric_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          required={true}
          errorMessage={errors.fabric_id}
        >
          <option value="">Select fabric</option>
          {fabrics.map((el) => (
            <option key={el.fabric_id} value={el.fabric_id}>
              {el.fabric_name}
            </option>
          ))}
        </FormField>
        <FormField
          label="Material"
          id="material_id"
          type="select"
          value={localData.material_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          
          errorMessage={errors.material_id}
        >
          <option value="">Select material</option>
          {materials.map((el) => (
            <option key={el.material_id} value={el.material_id}>
              {el.material_name}
            </option>
          ))}
        </FormField>
        <FormField
          label="Pattern"
          id="pattern_id"
          type="select"
          value={localData.pattern_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          
          errorMessage={errors.pattern_id}
        >
          <option value="">Select pattern</option>
          {patterns.map((el) => (
            <option key={el.pattern_id} value={el.pattern_id}>
              {el.pattern_name}
            </option>
          ))}
        </FormField>
        <FormField
          label="Neck type"
          id="neck_style_id"
          type="select"
          value={localData.neck_style_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          
          errorMessage={errors.neck_style_id}
        >
          <option value="">Select neck style</option>
          {neckStyleNames.map((el) => (
            <option key={el.neck_style_id} value={el.neck_style_id}>
              {el.neck_style_name}
            </option>
          ))}
        </FormField>
        <FormField
          label="Closure type"
          id="closure_type_id"
          type="select"
          value={localData.closure_type_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          
          errorMessage={errors.closure_type_id}
        >
          <option value="">Select closure type</option>
          {closuretypes.map((el) => (
            <option key={el.closure_type_id} value={el.closure_type_id}>
              {el.closure_type_name}
            </option>
          ))}
        </FormField>
        <FormField
          label="Back type"
          id="back_type_id"
          type="select"
          value={localData.back_type_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          
          errorMessage={errors.back_type_id}
        >
          <option value="">Select back type</option>
          {backTypeNames.map((el) => (
            <option key={el.back_type_id} value={el.back_type_id}>
              {el.back_type_name}
            </option>
          ))}
        </FormField>
        <FormField
          label="Sleeve"
          id="sleeve_id"
          type="select"
          value={localData.sleeve_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
          
          errorMessage={errors.sleeve_id}
        >
          <option value="">Select sleeve</option>
          {sleeves.map((el) => (
            <option key={el.sleeve_id} value={el.sleeve_id}>
              {el.sleeve_name}
            </option>
          ))}
        </FormField>
        <FormField
          label="Ornamentation"
          id="ornamentation_id"
          type="select"
          value={localData.ornamentation_id || ''}
          onChange={handleChange}
          onBlur={handleBlur}
        >
          <option value="">Select ornamentation</option>
          {ornamentation.map((el) => (
            <option key={el.ornamentation_id} value={el.ornamentation_id}>
              {el.ornamentation_name}
            </option>
          ))}
        </FormField>
      </div>
      <div className="flex justify-between pt-4">
        <button
          onClick={onBack}
          className="px-6 py-2 bg-gray-200 text-gray-700 font-medium rounded-lg shadow hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-400"
        >
          Back
        </button>
        <button
          onClick={handleNextClick}
          className="px-6 py-2 bg-blue-600 text-white font-medium rounded-lg shadow hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ProductUploadSpecificationForm;